import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PaymentLayoutActions, PaymentLayoutActionTypes } from './../actions/payment-layout.action';
import { Company } from './../../models/company';

export interface State extends EntityState<Company> { }

const adapter: EntityAdapter<Company> = createEntityAdapter<Company>({
    selectId: (company: Company) => company.companyCode,
    sortComparer: false
});

const initialState: State = adapter.getInitialState();

export function reducer(state = initialState, action: PaymentLayoutActions): State {
    switch (action.type) {
        case PaymentLayoutActionTypes.CLEAR_COMPANIES: {
            return initialState;
        }

        case PaymentLayoutActionTypes.LOAD_COMPANIES_SUCCESS: {
            return adapter.addMany(action.payload, state);
        }

        default: {
            return state;
        }
    }
}

export const getCompanies = (state: State) => state && state.entities;
